import { render, staticRenderFns } from "./paymentRecord.vue?vue&type=template&id=15dd937c&scoped=true&"
import script from "./paymentRecord.vue?vue&type=script&lang=ts&"
export * from "./paymentRecord.vue?vue&type=script&lang=ts&"
import style0 from "./paymentRecord.vue?vue&type=style&index=0&id=15dd937c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dd937c",
  null
  
)

export default component.exports